





































import {Component, Prop, PropSync, Vue, Emit} from 'vue-property-decorator'
import {
  DxSelectBox
} from 'devextreme-vue/ui/select-box';
import {
  DxValidator,
  DxRequiredRule,
  DxEmailRule,
  DxStringLengthRule
} from 'devextreme-vue/validator';

@Component({
  name: 'DSelectbox',
  components: {
    DxSelectBox,
    DxValidator,
    DxRequiredRule,
    DxEmailRule,
    DxStringLengthRule
  }
})
export default class extends Vue {

  @Prop() public dataSource!: any;
  @PropSync('inputData') synceInputData!: number | string;
  @Prop({ default: '' }) public title!: string;
  @Prop({ default: '' }) public placeholder!: string;
  @Prop({ default: false }) public isRequired!: boolean;
  @Prop({default: null}) public valueExpr!: string;
  @Prop({default: null}) public value!: any;
  @Prop({default: null}) public displayExpr!: string;
  @Prop({ default: false }) public searchEnable!: boolean;
  @Prop({default: null}) public searchExpr!: string;
  @Prop({default: 'contains'}) public searchMode!: 'contains' | 'startswith';
  @Prop({ default: false }) public isReadOnly!: boolean;
  @Prop({ default: false }) public acceptCustomValue!: boolean;
  @Prop({ default: () => {} }) public onChange!: Function;
  @Prop({ default: false }) public showClearButton!: boolean;
  @Prop({ default: false }) public disabled!: boolean;
  // Убирает нижнее подчеркивание для селектбоксов
  @Prop({default: false}) public hideUnderLine!: boolean;
  @Prop({default: false}) public hidePadding!: boolean;
  @Prop({}) public elementAttr!: any;



  created() {

  }

  public focus(): void {
    const selectbox = (this.$refs.selectbox as any).instance;
    selectbox.focus();
  }

  public get instance() {
    return (this.$refs.selectbox as any).instance;
  }

  onSelectionChange(e: any) {
    if (this.onChange) {
      this.onChange(e);

    }
  }

  @Emit("opened")
  onOpened(e:any) {
    return e;
  }

  @Emit("value-changed")
  onValueChanged(e:any) {
    return e;
  }

}
